export default {
  name: '用户指南',
  children: [
    {
      menuId: 1,
      name: '仪器预约流程',
      url: 'reservation',
    },
    {
      menuId: 2,
      name: '样品类型',
      url: 'sample',
    },
  ],
}
